/**
 * notice.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/18 下午5:40
 */

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Carousel, Row, Col, Pagination, Modal, Tabs } from 'neatui';
import deepCopy from 'deep-extend';
import TopStatistics from '../../common/topStats';
import action from '../../reduxModules/action';
import Loading from '../../common/loading';
import ajax from '../../util/ajax';
import stringifyUrlSearch from '../../util/stringifyUrlSearch';
import subString from '../../util/getLengthNSubstring';
import './style.module.scss';
import moment from 'moment';

const carouselData = {
  width: 930,
  height: 140,
  time: 0.5,
  interval: 5000,
  dotsDisplayType: 'hover',
  animationType: 'ease-in-out',
  arrowDisplayType: 'hover',
};

const spliceStr = (...argv) => subString(...argv, '...');

// 提示手机验证
const phoneVerify = id => {
  const { location, localStorage } = window;
  const result = JSON.parse(localStorage.getItem('phoneVerify'));
  const getDay = (+new Date() / (24 * 60 * 60 * 1000)) >>> 0; // 24h

  if (result === null || result[id] !== getDay) {
    Modal.confirm({
      title: '手机验证通知',
      content: (
        <p>
          为保障您的帐号安全请前往"
          <strong> 帐号信息 </strong>
          "页验证您的手机号，否则将影响帐号功能使用及收益提取。
        </p>
      ),
      size: 'md',
      okText: '去验证',
      onOk: () => (location.href = '/info.html'),
    });

    const phone = {
      [id]: getDay,
    };

    localStorage.setItem(
      'phoneVerify',
      JSON.stringify(result === null ? phone : deepCopy(result, phone)),
    );
  }
};

class Notice extends React.PureComponent {
  static propTypes = {};

  static defaultProps = {
    is: '', // 区分mcn/开发平台
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      pageNo: 1,
      pageSize: 10,
      leftPageNo: 1, // 左侧榜单分页
      leftPageSize: 11,
      scrollToValue: 0,
      loaded: true, // todo: 动画
      leftTopLoaded: true, // 左侧榜单
      leftActivityLoaded: true, // 左侧活动
      tabValue: 1, // 1显示活动，2榜单
    };
  }

  componentDidMount() {
    const { updateNotice, user } = this.props;
    this.getNoticeList();
    this.getTopList();
    this.getActivityList();
    // banner
    ajax('/index/banners.do', rs => {
      if (rs.data) {
        updateNotice('banner', rs.data.list.map(item => {
          const { pic } = item;
          const handledPic = /^http(s?):\/\/(cms\-bucket|dingyue)\.ws\.126\.net[\s\S]*01400061[0-9a-zA-Z]{1}\.(jpg|jpeg|png|gif)$/.test(pic) ?
            `https://nimg.ws.126.net/?url=${pic}&thumbnail=930x2147483647&quality=100&type=jpg` : pic;
          return { img: handledPic, ...item, pic: handledPic }
        }));
      }
    });
    setTimeout(() => {
      if (this.refs['news-list']) {
        this.setState({
          scrollToValue: this.refs['news-list'].getBoundingClientRect().top,
        });
      }
      // 手机号码未验证
      if (user.verifyState === 0) {
        phoneVerify(user.wemediaId);
      }
    }, 500);
  }

  // 平台公告
  getNoticeList = () => {
    const { pageNo, pageSize } = this.state;
    const { updateNotice } = this.props;
    // 列表
    return ajax(
      '/index/list.do',
      {
        params: {
          pageNo,
          pageSize,
        },
      },
      rs => {
        if (rs.data) {
          updateNotice([
            { key: 'list', value: rs.data.list },
            { key: 'total', value: rs.data.total },
          ]);
        }
      },
    );
  };

  // 获取左侧榜单
  getTopList = () => {
    const { leftPageNo, leftPageSize } = this.state;
    const { updateNotice } = this.props;
    return ajax(
      '/customer/articleListByElephont.do',
      {
        method: 'POST',
        params: {
          topicId: '00019LAL', // 产品指定的cms栏目,正式栏目00019LAL（测试栏目000181S1）
          pageNo: leftPageNo,
          size: leftPageSize,
        },
      },
      rs => {
        if (rs.data) {
          updateNotice([{ key: 'topList', value: { list: rs.data.list, total: rs.data.total } }]);
        }
      },
    );
  };

  // 获取左侧活动列表
  getActivityList = () => {
    const { updateNotice } = this.props;
    return ajax(
      '/index/activity/list.do',
      {
        method: 'POST',
        params: {
          state: 1, // 已发布状态
          pageNo: 1,
          size: 6,
        },
      },
      rs => {
        if (rs.data) {
          updateNotice([{ key: 'activity', value: { list: rs.data.list, total: rs.data.total } }]);
        }
      },
    );
  };

  handlePageChange = number => {
    this.setState(
      {
        pageNo: number,
        loaded: false,
      },
      () => {
        this.getNoticeList().then(() => {
          this.setState({
            loaded: true,
          });
        });
      },
    );
  };

  handleLeftPageChange = number => {
    this.setState(
      {
        leftPageNo: number,
        leftTopLoaded: false,
      },
      () => {
        this.getTopList().then(() => {
          this.setState({
            leftTopLoaded: true,
          });
        });
      },
    );
  };

  sendAndReport = (name) => {
    const { wemediaId } = this.props.user;
    window.antReport(`${name}-banner-首页`, wemediaId);
  }

  openNewPageByBannerUrl = obj => {
    const { user } = this.props;
    if (obj && obj.url) {
      this.sendAndReport(obj.title);
      const queryObj = stringifyUrlSearch(obj.url);
      const query = Object.keys(queryObj)
        .map(key => {
          let value;
          if (queryObj[key] === undefined) {
            // 支持 &@uid&@tid
            value = key;
            key = key.replace('@', '');
          } else {
            value = queryObj[key];
          }
          const isVar = /^@\w+$/.test(value); // tid=@tid || uid=@uid ...
          if (isVar) {
            if (key === 'uid') {
              queryObj[key] = user.loginUser;
            } else {
              queryObj[key] = user[value.replace('@', '')];
            }
          }
          return `${key}=${queryObj[key]}`;
        })
        .join('&');
      window.open(obj.url.split('?')[0] + (query.length > 0 ? `?${query}` : ''));
    }
  };

  onTab = value => {
    this.setState({
      tabValue: value,
    });
  };

  // 左侧榜单组件
  initTopList = () => {
    const { leftPageNo, leftPageSize, leftTopLoaded, scrollToValue } = this.state;
    const { list, total } = this.props.stone.topList;
    return (
      <Loading show={!leftTopLoaded}>
        <div className="main-news-list">
          {list.map((item, i) => (
            <Row key={`${item.id}-list-${i}`}>
              <Col className="left-colunmn">
                <a href={item.url} target="_blank" rel="noopener noreferrer" title={item.title}>
                  {i < 4 && leftPageNo === 1
                    ? spliceStr(item.title, 35)
                    : spliceStr(item.title, 42)}
                </a>
                {i < 4 && leftPageNo === 1 && <span className="tag">NEW</span>}
              </Col>
              <Col className="right-colunmn">
                <div className="time">{item.ptime && item.ptime.split(' ')[0]}</div>
              </Col>
            </Row>
          ))}
          <Row>
            <Col align="middle">
              <div className="page">
                <Pagination
                  total={total}
                  pageSize={leftPageSize}
                  current={leftPageNo}
                  showQuickJump
                  onChange={this.handleLeftPageChange}
                  scrollTime={0.6}
                  tweenName="easeInOutExpo"
                  btnProp={{ size: 'small' }}
                  scrollToValue={scrollToValue}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Loading>
    );
  };

  // 左侧活动
  initActivityList = () => {
    const { leftActivityLoaded } = this.state;
    const { list, total } = this.props.stone.activity;
    const tagMap = {
      1: '图文',
      2: '视频',
      3: '图文&视频',
    };
    return (
      <Loading show={!leftActivityLoaded}>
        <div styleName="activity_wrap">
          {list.map((item, i) => (
            <Row styleName="item_wrap" key={`${item.id}-list-${i}`}>
              <div styleName="left_img_wrap">
                {item.urlFlag ? (
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <img src={item.pic} alt="活动" />
                  </a>
                ) : (
                  <img src={item.pic} alt="活动" />
                )}
              </div>
              <div styleName="right_title_wrap">
                <div styleName="text_wrap">
                  {/* 活动类型 标签 */}
                  {item.activityType ? (
                    <span styleName="activity_tag">{tagMap[item.activityType]}</span>
                  ) : null}
                  {/* 活动领域 标签*/}
                  {item.activityField ? (
                    <span styleName="activity_tag">{item.activityField}</span>
                  ) : null}
                  {item.urlFlag ? (
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      {item.title}
                    </a>
                  ) : (
                    <span>{item.title}</span>
                  )}
                </div>
                <div styleName="other_tips_wrap">
                  {item.activityEndTime
                    ? this.renderActivityTime(item.activityStartTime, item.activityEndTime)
                    : null}
                </div>
              </div>
            </Row>
          ))}
        </div>
      </Loading>
    );
  };

  renderActivityTime = (startDate, endDate) => {
    const diff = moment(endDate).diff(moment(new Date()), 'day');
    if (diff >= 0) {
      const startDateFormat = moment(startDate).format('YYYY.M.D');
      const endDateFormat = moment(endDate).format('YYYY.M.D');
      return (
        <span>
          {startDateFormat}-{endDateFormat}
        </span>
      );
    } else {
      return <span>已结束</span>;
    }
  };

  render() {
    const { stone, user, is } = this.props;
    const { pageNo, loaded, scrollToValue, pageSize, tabValue } = this.state;
    const { device } = window.platformOfRuntime;
    // 账号类型(accountType): 0-媒体，1-自媒体，2-组织机构，3-直播号，4-企业
    // 主体类型(ownerType): 0 - 企业；1 - 个人；2 - 机构；3 - 媒体；4 - 其他
    const isMcn = is === 'mcn';
    // 组织机构、企业号、直播号 不展示“网易号指数”
    const isNoStar = [2, 3, 4].indexOf(user.accountType) > -1;
    const topShow = [
      {
        name: '总订阅',
        key: 'totalSubscribeCount',
        url: isMcn ? '/statistic/screen' : '/subscribe-data',
      },
      {
        name: '总阅读',
        key: 'totalReadCount',
        url: isMcn ? '/statistic/screen' : '/content-data',
      },
      {
        name: '昨日阅读',
        key: 'yesterdayReadCount',
        url: isMcn ? '/statistic/screen' : '/content-data',
      },
    ].concat(
      isMcn
        ? [
            {
              name: '上月收益',
              key: 'lastMonthIncome', // 待定字段
              url: '/income/profit',
            },
          ]
        : isNoStar
        ? []
        : [
            {
              name: '网易号指数',
              key: 'totalIndex',
              url: '/star-level',
            },
          ],
    );
    return (
      <div>
        <div className="page-top">
          <TopStatistics url="/index/count.do" showTitle={topShow} />
          {device !== 'mcn' ? (
            <div className="release-btn-wrap">
              <Button
                type="primary"
                className="release-btn"
                icon="edit-o"
                onClick={() => {
                  window.location.href = `/index.html#/post/article?wemediaId=${user.wemediaId}`;
                }}>
                发布图文
              </Button>
              <Button
                type="primary"
                className="release-btn"
                icon="edit-o"
                onClick={() => {
                  window.location.href = `/index.html#/post/video?wemediaId=${user.wemediaId}`;
                }}>
                发布视频
              </Button>
            </div>
          ) : null}
        </div>
        {stone.banner.length > 0 && (
          <Carousel {...carouselData} className="carousel">
            {stone.banner.map((item, index) => (
              <div
                className="custom-item"
                key={index}
                style={{ width: carouselData.width, height: carouselData.height }}
                onClick={() => this.openNewPageByBannerUrl(item)}>
                <img src={item.pic} alt={item.title} />
              </div>
            ))}
          </Carousel>
        )}
        <div styleName="main-wrap">
          <div styleName="left-wrap">
            <div className="panel main-left-panel">
              <div className="panel-header">
                <Tabs
                  value={tabValue}
                  onChange={(e, value) => {
                    this.onTab(value);
                  }}>
                  <Tabs.Tab value={1}>活动</Tabs.Tab>
                  <Tabs.Tab value={2}>榜单</Tabs.Tab>
                </Tabs>
              </div>
              <div className="panel-body">
                {tabValue === 1 ? this.initActivityList() : this.initTopList()}
              </div>
            </div>
          </div>
          <div styleName="right-wrap">
            <Loading show={!loaded}>
              <div className="panel main-right-panel" ref="news-list">
                <div className="panel-header">平台公告</div>
                <div className="panel-body main-news-list">
                  {/* {pageNo === 1 && ( */}
                  <Row>
                    <Col className="left-colunmn">
                      <a
                        href="/media_static/html/handbook.html"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#e25050' }}>
                        《网易号运营指导手册》
                      </a>
                    </Col>
                    {/* <Col className="right-colunmn">
                        <div className="time">2017-04-17 10:00:00</div>
                      </Col> */}
                  </Row>
                  {/* // )} */}
                  {stone.list.map((item, i) => (
                    <Row key={`${item.id}-list-${i}`}>
                      <Col className="left-colunmn">
                        <a
                          href={`//dy.163.com/article/${item.id}.html`}
                          target="_blank"
                          title={item.title}
                          rel="noopener noreferrer">
                          {i < 4 && pageNo === 1
                            ? spliceStr(item.title, 35)
                            : spliceStr(item.title, 42)}
                        </a>
                        {i < 4 && pageNo === 1 && <span styleName="primary-tag">NEW</span>}
                      </Col>
                      <Col className="right-colunmn">
                        <div className="time">
                          {item.createTime && item.createTime.split(' ')[0]}
                        </div>
                      </Col>
                    </Row>
                  ))}
                  <Row>
                    <Col align="middle">
                      <div className="page">
                        <Pagination
                          total={stone.total}
                          pageSize={pageSize}
                          current={pageNo}
                          showQuickJump
                          onChange={this.handlePageChange}
                          scrollTime={0.6}
                          tweenName="easeInOutExpo"
                          btnProp={{ size: 'small' }}
                          scrollToValue={scrollToValue}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Loading>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    stone: state.notice,
    user: state.common.user,
  }),
  dispatch =>
    bindActionCreators(
      {
        updateNotice: action.updateNotice,
      },
      dispatch,
    ),
)(Notice);
